


































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Account } from '@/api/generated'
import { Injector } from '@/config/dependency-injection'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import { NotificationService } from '@/shared/services/notification-service'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'
import { DialogService } from '@/shared/dialog/dialog-service'
import CreateAccountDialog from '@/business/administration/components/create-account/create-account-dialog.vue'
import { BvTableFieldArray } from 'bootstrap-vue'
import { i18n } from '@/config/i18n'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import { LoaderHelper } from '@/shared/services/loader-helper'
import RespondecoPagination from '@/main/respondeco-pagination.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { resetPasswordDialog } from '@/business/administration/components/reset-password'
import { AdminService } from '@/business/administration/admin-service'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  name: 'account-overview',
  components: {
    UnifyButton,
    RespondecoLoadingIndicator,
    RespondecoPagination,
    RespondecoTypedForm,
    RespondecoForm,
    RespondecoFormGroup,
  },
})
export default class AccountOverview extends Vue {
  public filter: string = ''
  public page: number = 1
  public pageSize: number = 15

  public fields: BvTableFieldArray = [
    {
      key: 'name',
      sortable: true,
      tdClass: 'align-middle',
      thClass: 'align-middle',
    },
    {
      key: 'email',
      sortable: true,
      tdClass: 'align-middle',
      thClass: 'align-middle',
    },
    {
      formatter: value => i18n.d(value, 'long'),
      key: 'createdAt',
      sortByFormatted: (value: Date) => value.getTime(),
      sortable: true,
      tdClass: 'align-middle text-nowrap',
      thClass: 'align-middle',
    },
    {
      key: 'actions',
      tdClass: 'align-middle pl-5 text-right text-nowrap',
      thClass: 'align-middle text-right',
    },
  ]

  public sortBy: string = 'createdAt'
  public sortDesc: boolean = true

  private adminModule = Injector.get(AdministrationModule)
  private adminService = Injector.get(AdminService)
  private dialogService = Injector.get(DialogService)
  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private router = Injector.get<VueRouter>(RouterToken)

  public get accounts(): Account[] {
    return this.adminService?.state.accounts ?? []
  }

  public get loading(): boolean {
    return this.loaderHelper.isLoading('admin_get-accounts')
  }

  public impersonate(username: string) {
    this.adminModule.impersonateAccount({ username }).then(account => {
      this.notificationService.success()

      this.router.push({
        name: 'organisation',
        params: {
          id: String(account.organisation.id),
        },
      })
    })
  }

  public openCreateAccountDialog(): void {
    this.dialogService.openDynamic(CreateAccountDialog)
  }

  public openResetPasswordDialog(account: Account): void {
    resetPasswordDialog({
      account,
    })
  }

  public search(includeDeleted: boolean = false): void {
    this.adminService.getAccounts({
      includeDeleted,
    })
  }

  public toggleSpam(accountId: number, spam: boolean): void {
    this.adminService.markAccountAsSpam({ accountId, spam })
  }
}
